import React from "react";

function CatEditIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        fill="#4F4F4F"
        d="M13.167 3.117L10.884.833A1.667 1.667 0 008.667.775l-7.5 7.5c-.27.272-.437.628-.475 1.008l-.358 3.475a.833.833 0 00.833.909h.075l3.475-.317c.38-.038.737-.206 1.008-.475l7.5-7.5a1.6 1.6 0 00-.058-2.258zM10.334 5.9L8.1 3.667 9.725 2 12 4.275 10.334 5.9z"
      ></path>
    </svg>
  );
}

export default CatEditIcon;
